import { render, staticRenderFns } from "./RegisterCode.vue?vue&type=template&id=247c6af6&scoped=true&"
import script from "./RegisterCode.vue?vue&type=script&lang=js&"
export * from "./RegisterCode.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCode.vue?vue&type=style&index=0&id=247c6af6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c6af6",
  null
  
)

export default component.exports